<template>
  <BaseStyle
    :content-style="model.style"
    class="content-base"
  >
    <div
      class="flex flex-wrap w-full"
      :class="[
        model.alignItems === 'TOP' && 'items-start',
        model.alignItems === 'CENTER' && 'items-center',
        model.alignItems === 'BOTTOM' && 'items-end',
      ]"
    >
      <div
        v-for="(horizontalItem, index) in model.items"
        :key="index"
        :style="horizontalItem.width ? {
          width: horizontalItem.width
        } : {}"
      >
        <div
          v-for="(content, contentIndex) in horizontalItem.contents"
          :key="contentIndex"
        >
          <Content :content="content" />
        </div>
      </div>
    </div>
  </BaseStyle>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent, PropType } from 'vue';

import { ContentHorizontalLayoutModel } from '@/models/content_horizontal_layout_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentHorizontalLayout',
  components: {
    BaseStyle,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Content: defineAsyncComponent((): any => import('./Content.vue')),
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentHorizontalLayoutModel>,
      required: true,
    },
  },
});
</script>
